import { FlexView, Text, Icon } from '@components/Common';
import languages from '@locales/languages';
import { Colors } from '@styles/system';

import ModalP from './ModalP';

interface ModalProps {
  language: 'ko' | 'en';
  closePortal: () => void;
}

export default ({ language, closePortal }: ModalProps) => {
  const TEXTS = languages[language].modal;

  // const wrapperCSS = {
  //   backgroundColor: Colors.gray700,
  //   borderRadius: `8px`,
  //   width: `160px`,
  //   minHeight: `64px`,
  //   display: `flex`,
  //   alignItems: `center`,
  //   justifyContent: `center`,
  // };

  return (
    <ModalP closePortal={closePortal} height={680} width={680} close>
      <FlexView
        css={{
          minHeight: 0,
          paddingTop: `8px`,
          overflowY: `auto`,
          scrollbarWidth: `none`,
          '::-webkit-scrollbar': { display: `none` },
        }}
        gap={24}
        fill
      >
        {/* 기존 앱 다운로드 안내 문구 (롤백 대비 보존)
        <FlexView gap={24}>
          <Icon color={Colors.primary} name="logo" size={28} />
          <Text color={Colors.secondary70} multiLine>
            {TEXTS.downloadGuide}
          </Text>
        </FlexView> */}

        {/* 기존 앱 스토어 다운로드 버튼 (롤백 대비 보존)
        <FlexView content="center" gap={24} row>
          <Anchor
            css={wrapperCSS}
            href="https://apps.apple.com/us/app/blockchat/id1635256021"
            referrerPolicy="no-referrer"
            target="_blank"
          >
            <Icon color={Colors.white} name="appStore" size={24} />
          </Anchor>
          <Anchor
            css={wrapperCSS}
            href="https://play.google.com/store/apps/details?id=com.blockchainlabs.android"
            referrerPolicy="no-referrer"
            target="_blank"
          >
            <Icon color={Colors.white} name="googlePlay" size={20} />
          </Anchor>
        </FlexView> */}

        {/* 기존 안내 사항 및 문의 문구 (롤백 대비 보존)
        <FlexView gap={24}>
          <Text color={Colors.secondary} medium multiLine>
            {TEXTS.notice}
          </Text>
          <FlexView gap={24}>
            <FlexView gap={12} row>
              <Text color={Colors.secondary70} css={{ lineHeight: `150%` }}>
                1.
              </Text>
              <Text color={Colors.secondary70} multiLine>
                {TEXTS.notice1}
              </Text>
            </FlexView>
          </FlexView>
        </FlexView>
        {language === `ko` && (
          <FlexView gap={4}>
            <Text color={Colors.secondary70}>{TEXTS.advice1}</Text>
            <Text color={Colors.secondary70}>
              <Text color={Colors.primary}>{`${TEXTS.email} `}</Text>
              {TEXTS.advice2}
            </Text>
          </FlexView>
        )}
        {language === `en` && (
          <FlexView gap={4}>
            <Text color={Colors.secondary70}>{TEXTS.advice1}</Text>
            <Text color={Colors.secondary70}>
              {`${TEXTS.advice2} `}
              <Text color={Colors.primary}>{TEXTS.email}</Text>
            </Text>
          </FlexView>
        )} */}

        <FlexView gap={12} items="start">
          <Icon color={Colors.primary} name="logo" size={28} />
          <Text color={Colors.secondary} large multiLine semiBold>
            {TEXTS.serviceEndTitle}
          </Text>
        </FlexView>

        <FlexView gap={20}>
          <Text color={Colors.secondary70} multiLine>
            {TEXTS.serviceEndGreeting}
          </Text>
          <Text color={Colors.secondary70} multiLine>
            {TEXTS.serviceEndThanks}
          </Text>
          <Text color={Colors.secondary} multiLine semiBold>
            {TEXTS.serviceEndDate}
          </Text>
          <Text color={Colors.secondary} multiLine semiBold>
            {TEXTS.serviceEndAvailability}
          </Text>
          <Text color={Colors.secondary} multiLine semiBold>
            {TEXTS.serviceEndDataDisposal}
          </Text>
          <Text color={Colors.secondary70} multiLine>
            {TEXTS.serviceEndNoStoredData}
          </Text>
          <Text color={Colors.secondary70} multiLine>
            {TEXTS.serviceEndClosing}
          </Text>
          <FlexView gap={4}>
            <Text color={Colors.secondary70} multiLine>
              {TEXTS.serviceEndContact}
            </Text>
            <Text color={Colors.primary} semiBold>
              {TEXTS.serviceEndContactEmail}
            </Text>
          </FlexView>
        </FlexView>
      </FlexView>
    </ModalP>
  );
};
